import { render, staticRenderFns } from "./rechargeDesc.vue?vue&type=template&id=242d6f28&scoped=true&"
import script from "./rechargeDesc.vue?vue&type=script&lang=js&"
export * from "./rechargeDesc.vue?vue&type=script&lang=js&"
import style0 from "./rechargeDesc.vue?vue&type=style&index=0&id=242d6f28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d6f28",
  null
  
)

export default component.exports